const INTERACTIVE_CONTROL_SELECTOR = [
  "button",
  "input",
  "select",
  "textarea",
  "a[href]",
  "[role='button']",
  "[contenteditable='true']",
].join(",");

export function isInteractiveControlTarget(target: EventTarget | null): boolean {
  if (!target || !("closest" in target) || typeof target.closest !== "function") return false;
  return target.closest(INTERACTIVE_CONTROL_SELECTOR) !== null;
}
